export const getFromLocalStorage = (key) => {
    if (typeof localStorage !== 'undefined') {
        const item = localStorage.getItem(key);
        if (item) {
            const parsedItem = JSON.parse(item);
            const { value, expires } = parsedItem;
            if (expires === null || expires >= Date.now()) {
                return value;
            } else {
                localStorage.removeItem(key);
            }
        }
    }
    return null;
};

export const removeFromLocalStorage = (key) => {
    if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(key);
    }
};

export const addToLocalStorage = (key, value, days) => {
    if (typeof localStorage !== 'undefined') {
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            localStorage.setItem(
                key,
                JSON.stringify({
                    value,
                    expires: date.getTime(),
                })
            );
        } else {
            localStorage.setItem(
                key,
                JSON.stringify({
                    value,
                    expires: null,
                })
            );
        }
    }
};

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};

export const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

export const getFromCookies = (key) => {
    const cookieValue = getCookie(key);
    if (cookieValue) {
        try {
            const parsedItem = JSON.parse(cookieValue);
            const { value, expires } = parsedItem;
            if (expires === null || expires >= Date.now()) {
                return value;
            } else {
                setCookie(key, '', -1); // Eliminar cookie si ha expirado
            }
        } catch (_error) {
            return null;
        }
    }
    return null;
};

export const addToCookies = (key, value, days) => {
    if (days) {
        setCookie(
            key,
            JSON.stringify({
                value,
                expires: new Date().getTime() + days * 24 * 60 * 60 * 1000,
            }),
            days
        );
    } else {
        setCookie(
            key,
            JSON.stringify({ value, expires: null }),
            30 // Guardar por defecto 1 año si no se define `days`
        );
    }
};

export const removeFromCookies = (key) => {
    setCookie(key, '', -1); // Eliminar cookie estableciendo un tiempo en el pasado
};
